import { createFileRoute } from '@tanstack/react-router';
import OnboardingPhone from '@/features/account/onboarding/phone';

export const Route = createFileRoute('/onboarding/celular')({
  component: OnboardingPhone,
});
